enum EItemDetailsTab {
  ItemDetails = "itemDetails",
  ItemHistory = "itemHistory",
  ItemPhotos = "itemPhotos",
  QualityCheck = "qualityCheck",
  Channels = "channels",
}

export default EItemDetailsTab;
